import { creatorsApi, GetCreatorsReturn, GetCreatorsParams } from 'api';
import { createFetchStore } from 'utils';

export const {
  useFetchStore: useCreatorsStore,
  useFetchData: useFetchCreators,
} = createFetchStore<GetCreatorsReturn, GetCreatorsParams>(creatorsApi.getList);
